import { CustomerMasterSourceType } from 'generated/bffFinancialInfo/models';
import { apiClient, ExtendedAxiosResponse } from 'helpers/apiClient';
import { ChannelType } from 'models/ChannelType';

export const api = {
  getInstallmentCalendarList: (
    url: string,
    filter: string,
    subordinate?: boolean | undefined
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/installment-document/list`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        forceCheck: false,
        subordinate,
        filter,
      },
    }),

  getInstallmentCalendarDetail: (url: string, caRefNo: string, installmentId: string): Promise<ExtendedAxiosResponse> =>
    apiClient.get(`${url}/installment-document/detail`, {
      params: {
        channel: ChannelType.MO2_CARE,
        customerMasterSource: CustomerMasterSourceType.O2POP,
        forceCheck: false,
        caRefNo,
        installmentId,
      },
    }),
};
